import { fontStyleHeadings2 } from "components/Common/styles.js";

export const journeyPlanStyles = {
  journeyPlanSummaryHeadingContainer: {
    default: {
      padding: "30px 0px 30px 15px",
    },
    retro: { padding: "30px 0px 0px 15px" },
    electric: { padding: "30px 0px 0px 15px" },
  },
  journeyPlanSummaryHeadingStyle: fontStyleHeadings2,
};



// WEBPACK FOOTER //
// ./src/components/JourneyPlan/styles/JourneyPlanPageStyle.js